import {BusinessTransactionWorkQueueDetailModel} from './business-transaction-work-queue-detail-model';
import {UserLoginModel} from './user-login.model';

export class WorkQueueModel {
    constructor(data: any) {
        if (data) {
            this.workQueueId = data.id;
            this.escalationWorkQueueId = data.escalationWorkQueueId;
            this.businessUnitId = data.businessUnitId;
            this.workQueueValue = data.workQueueValue;
            this.workQueueTypeID = data.workQueueTypeID;
            this.active = data.active;
            this.isPersonalQueue = data.isPersonalQueue;
            this.canManageWorkQueue = data.canManageWorkQueue;

            if (data.businessTransactionDetails) {
                this.businessTransactionDetails = data.businessTransactionDetails.map(x => new BusinessTransactionWorkQueueDetailModel(x));
            }

            if (data.users) {
                this.userLogins = data.users.map(x => new UserLoginModel(x));
            }
        }
    }

    workQueueId: number;
    escalationWorkQueueId: number;
    businessUnitId: number;
    workQueueTypeID: number;
    workQueueValue: string;
    active: boolean;
    isPersonalQueue: boolean;
    canManageWorkQueue: boolean;

    businessTransactionDetails: BusinessTransactionWorkQueueDetailModel[];
    userLogins: UserLoginModel[];
}
